module.exports = __webpack_public_path__ + "static/media/virus-like-particle.0bd1e07f.jpg";